import moment from 'moment';
import React, { Component } from "react";
import LoadingOverlay from 'react-loading-overlay';
import AuthContext from '../auth-context';
import TrialCoachingSessionsService from '../utils/TrialCoachingSessionsService';
import UsersService from '../utils/UsersService';
import Calendar from "./Calendar";
import './Calendar.css';


class TCSCalendarView extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context
    this.isRestrictedCoach = authStore.hasRole('coach_restricted')
    const assigned = this.isRestrictedCoach ? authStore.profile.email : ""
    this.state = { filter: { view: 'list', assigned: assigned, includeCompleted: false }, events: [], coaches: [], begin: moment(), end: moment().add(30, 'days') };

    this.handleViewClick = this.handleViewClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateRangeChanged = this.dateRangeChanged.bind(this);
  }

  dateRangeChanged(begin, end) {
    this.setState({ begin: begin, end: end }, () => this.fetchEvents())
  }

  handleViewClick(id) {
    this.props.history.push(`/m1/tcs/${id}`)
  }

  handleFilterChange(event) {
    let filter = {...this.state.filter}
    filter[event.target.id] = event.target.value
    this.setState({filter})
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    this.fetchEvents()
    this.fetchCoaches()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.filter !== prevState.filter) {
      this.fetchEvents()
    }
  }

  fetchEvents() {
    this.setState({ loadingInProgress: true });
    TrialCoachingSessionsService.index({ filter: this.state.filter, begin: this.state.begin, end: this.state.end }).then(data => {
      let events = data.results.map((item) => {
        if (item.tcs_assigned_to) { item.tcs_assigned_to_name = `${item.tcs_assigned_to.first_name} ${item.tcs_assigned_to.last_name}` }
        let end;
        switch (item.booking_from) {
          case 'web':
            end = moment(item.tcs_at).add(30, 'minutes').toDate()
            break
          case 'seminar':
            end = moment(item.tcs_at).add(45, 'minutes').toDate()
            break
          case 'callcentre':
            end = moment(item.tcs_at).add(45, 'minutes').toDate()
            break
          default:
            end = moment(item.tcs_at).add(45, 'minutes').toDate()
            break
        }

        let calendarProps = {
          title: item.email,
          start: moment(item.tcs_at).toDate(),
          end: end,
          allDay: false,
          item: item,
          desc: `${item.first_name} ${item.email} (${item.tcs_assigned_to_name || 'unassigned'})`,
          tooltip: `${item.first_name} ${item.email} (${item.tcs_assigned_to_name || 'unassigned'})`
        }
        return {...item, ...calendarProps}
      })
      this.setState({ loadingInProgress: false, events: events })
    });
  }

  fetchCoaches() {
    UsersService.allUsers().then(data => {
      this.setState({ coaches: data.filter((c) => c.roles.includes('coach')) })
    })
  }

  render() {
    const { loadingInProgress } = this.state;

    return (
      <LoadingOverlay
        active={loadingInProgress}
        spinner
        fadeSpeed={1}
        styles={{
          overlay: (base) => ({
            ...base,
            background: "rgba(255, 255, 255, 0.9)",
          }),
        }}
        text="Getting events..."
      >
        <h3 className="first-title">Trial Coaching Sessions</h3>
        {!this.isRestrictedCoach && (
          <div className="row" style={{ marginBottom: "10px" }}>
            <div className="col-sm-3">
              <select
                id="assigned"
                value={this.state.filter.assigned}
                onChange={this.handleFilterChange}
              >
                <option value="">(assigned to anyone)</option>
                <option value="unassigned">(NOT assigned)</option>
                {this.state.coaches.map((coach) => (
                  <option key={coach.email} value={coach.email}>
                    {coach.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-sm-12">
            <Calendar
              events={this.state.events}
              dateRangeChanged={this.dateRangeChanged}
            />
          </div>
        </div>
        <div>
          <h4>Event Key</h4>
          <span className="event-key web">Web Booking</span>
          <span className="event-key seminar">Seminar Booking</span>
          <span className="event-key callcentre">Call Centre</span>
          <span className="event-key unassigned">Unassigned</span>
          <span className="event-key confirmed">
            <i className="fas fa-star" aria-hidden="true"></i> = Confirmed
          </span>
        </div>
      </LoadingOverlay>
    );
  }
}
export default TCSCalendarView